
const tools = {
  // 判断是否移动端
  isMoble () {
    const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag
  },
  // 判断是否苹果手机
  isIOS () {
    var u = navigator.userAgent
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    return isIOS
  },
  // 是否微信或qq
  isWXQQ () {
    var ua = navigator.userAgent.toLowerCase()
    var isWx = false

    var isIosQQ = (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) && /\sQQ/i.test(navigator.userAgent))
    var isAndroidQQ = (/(Android)/i.test(navigator.userAgent) && /MQQBrowser/i.test(navigator.userAgent) && /\sQQ/i.test((navigator.userAgent).split('MQQBrowser')))

    // eslint-disable-next-line eqeqeq
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      // 微信浏览器
      isWx = true
    }
    // return true;
    return isWx || isIosQQ || isAndroidQQ
  },
  openH5Url (url) {
    console.log('新页面打开：' + url)
    var a = document.createElement('a')
    if (!a.click) {
      window.location = url
      return
    }
    a.setAttribute('href', url)
    a.setAttribute('target', '_blank')
    a.style.display = 'none'
    document.body.appendChild(a)
    a.click()
  },
  // 跳转到小程序（附加渠道参数）
  openWxMiniGame (url) {
    this.openH5Url(url)
  },
  // 模拟点击下载
  iosDoLocation (url) {
    console.log('当前页打开：' + url)
    var a = document.createElement('a')
    if (!a.click) {
      window.location = url
      return
    }
    a.setAttribute('href', url)
    a.style.display = 'none'
    document.body.appendChild(a)
    a.click()
  },
  // 是否苹果电脑
  isMac () {
    return /macintosh|mac os x/i.test(navigator.userAgent)
  },
  // base Url
  apiBaseUrl: 'https://api.56wuyou.com:9497',
  // 发送 post 请求
  post (api, data, callBack) {
    const url = this.apiBaseUrl + api
    // 第一步：创建需要的对象
    const httpRequest = new XMLHttpRequest()
    // 第二步：打开连接/***发送json格式文件必须设置请求头 ；如下 - */
    httpRequest.open('POST', url, true)
    // 设置请求头 注：post方式必须设置请求头（在建立连接后设置请求头）
    httpRequest.setRequestHeader('Content-type', 'application/json')
    // 发送请求 将json写入send中
    httpRequest.send(JSON.stringify(data))
    // 请求后的回调接口，可将请求成功后要执行的程序写在其中
    httpRequest.onreadystatechange = function () {
      // 验证请求是否发送成功
      if (httpRequest.readyState === 4 && httpRequest.status === 200) {
        // 获取到服务端返回的数据
        const json = httpRequest.responseText
        callBack && callBack(JSON.parse(json))
      }
    }
  },
  get (api, data, callBack) {
    const url = this.apiBaseUrl + api + this.objToParam(data)
    // 第一步：建立所需的对象
    var httpRequest = new XMLHttpRequest()
    // 第二步：打开连接  将请求参数写在url中  ps:"./Ptest.php?name=test&nameone=testone"
    httpRequest.open('GET', url, true)
    // 第三步：发送请求  将请求参数写在URL中
    httpRequest.send()
    /**
     * 获取数据后的处理程序
     */
    httpRequest.onreadystatechange = function () {
      if (httpRequest.readyState === 4 && httpRequest.status === 200) {
        // 获取到json字符串，还需解析
        var json = httpRequest.responseText
        callBack && callBack(JSON.parse(json))
      }
    }
  },
  // 对象参数转 url get 参数
  objToParam (vobj) {
    if (!vobj) {
      return ''
    }
    let str = '?'
    for (const key in vobj) {
      const one = vobj[key]
      const isObj = one instanceof Object
      str += key + '=' + (isObj ? JSON.stringify(one) : one) + '&'
    }

    return str.substring(0, str.length - 1)
  },
  // 获取连接附带参数
  getUrlParam (variable) {
    const query = window.location.search.substring(1)
    const vars = query.split('&')
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=')
      if (pair[0] === variable) {
        return pair[1]
      }
    }
    return ''
  },
  // 从href里取参数
  getHrefParam () {
    const href = window.location.href
    const begin = href.indexOf('?')
    if (begin < 0) {
      return ''
    }
    return href.substring(begin)
  },
  // 发送安装参数消息
  sendInstallParam () {
    // 先不用了
    const isOk = false
    if (!isOk) {
      return
    }
    // 获取连接附带参数
    let inStr = window.location.search
    if (inStr === '') {
      inStr = this.getHrefParam()
    }
    inStr = window.btoa(inStr)
    const param = {
      // 全部参数都传回去吧，里面怎么处理都行了

      search: inStr
    }
    // this.post('/web/open_share_url', param, function (data) {
    //   console.log(data)
    // })
    this.get('/web/open_share_url', param, function (data) {
      // console.log(data)
    })
  },
  // 保存 openinstall app 对象
  _openInstallApps: {},
  // 根据 key 获取 openinstall 对象
  getOpenInstall (key) {
    return this._openInstallApps[key]
  },
  // 初始化 openinstall
  initOpenInstall (config) {
    // 没开启就不处理
    if (!config.isOpen) {
      return
    }

    const self = this

    // 单个注册
    const initOne = function (key, params) {
      // 没有 appKey 的就不处理了
      if (!params.AppKey) {
        console.error(key + '：openinstall 没有 AppKey')
        return
      }
      // openinstall.js中提供的api，解析当前网页url中的查询参数并对data进行赋值
      const data = window.OpenInstall.parseUrlParams()
      // 初始化方法，与openinstall服务器交互，应尽早调用
      const m = new window.OpenInstall({
        // appKey为openinstall为应用分配的唯一id（必须传入）
        appKey: params.AppKey,
        onready: function () {
          // 初始化成功回调方法。当初始化完成后，会自动进入
          // 保存 openinstall 对象
          self._openInstallApps[key] = this
        }
      }, data)
      // 初始化时传入data，作为一键拉起/App传参安装时候的参数
      console.log(m)
    }

    // 列表里的都创建出来
    for (const key in config.apps) {
      const one = config.apps[key]
      initOne(key, one)
    }
  },
  // 安装
  openinstallDown (key) {
    const obj = this._openInstallApps[key]
    if (!obj) {
      console.error('openinstallDown：没有找到 ' + key + ' 对应的 openinstall 对象')
      return
    }
    // 此方法为scheme、Universal Link唤醒以及引导下载的作用（必须调用且不可额外自行跳转下载）
    obj.wakeupOrInstall()
  }
}

export default tools
